import React, { Component } from 'react';

class Square extends Component {
  render() {
    return (
      <div className={'square ' + (this.props.value ? 'active' : '')}
      onClick={() => this.props.onClick()}>
      </div>
    );
  }
}

export default Square;



// WEBPACK FOOTER //
// ./src/Square.js